import { useMemo } from 'react';
import { useApprovalContext } from './useApprovalContext';
export const useApproversInfo = () => {
  const approval = useApprovalContext();
  const approverActorIds = useMemo(() => {
    if (!approval.data) {
      return [];
    }
    return approval.data.approvalSteps.map(step => step.approver.actor.id);
  }, [approval.data]);
  const approvedApproverActorIds = useMemo(() => {
    if (!approval.data) {
      return [];
    }
    return approval.data.approvalSteps.filter(step => step.approvalStepStatus === 'APPROVED').map(step => step.approver.actor.id);
  }, [approval.data]);
  return {
    approverActorIds,
    approvedApproverActorIds
  };
};